<template>
  <div class="purchaserBanner">
    <div class="sky">
      <div class="clouds_one"></div>
      <div class="clouds_two"></div>
      <div class="clouds_three"></div>
    </div>
    <!--<div id="carousel-example-generic" class="carousel slide" data-ride="carousel">-->
      <!--&lt;!&ndash; Indicators &ndash;&gt;-->
      <!--<ol class="carousel-indicators">-->
        <!--<li data-target="#carousel-example-generic" v-for='(banner,index) in bannerInfo' :key="index" :class="index == 0? 'active' : ''" :data-slide-to="index"></li>-->
      <!--</ol>-->
      <!--&lt;!&ndash; Wrapper for slides &ndash;&gt;-->
      <!--<div class="carousel-inner" role="listbox">-->
          <!--<div  v-for='(banner,index) in bannerInfo' :key="index" :class="index == 0? 'item active' : 'item'" >-->
              <!--<img  :src='banner.bannerPicturePath' @click='jump(banner.bannerPictureJumpLink)' alt="一链网"/>-->
            <!--<div class="carousel-caption">-->
            <!--</div>-->
          <!--</div>-->
      <!--</div>-->
    <!--</div>-->
    <el-carousel :interval="ratationTime" arrow="never" id="el-carousel"  v-loading="loading" @change="activeNumFn" ref="carousel" :autoplay="autoScroll">
      <el-carousel-item v-for="(banner,index) in bannerInfo" :key="index">
        <img :class="'imgHeight'+index" :src='banner.bannerPicturePath' @click='jump(banner.bannerPictureJumpLink, banner, index)' alt="一链网"/>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
  import {customOperationClick} from '@/assets/js/sensors'
export default {
  props: ['bannerInfo','ratationTime','loading'],
  data(){
    return{
      bannerHeight:360,
      activeNum:0,
      autoScroll:true
    }
  },
  components: {
  },
  mounted(){
    this.bannerTime();
    this.setHeight();
    this.bannerScroll();
  },
  methods: {
    bannerTime () {
      // $('.carousel').carousel({
      //   interval: this.ratationTime
      // })
    },
    jump(url, item, index){
      // 埋点
      try {
        customOperationClick({
          page_title: "招标公告",
          operation_type: `招标公告轮播图`,
          operation_content: '广告图片',
          operation_name: `招标公告-${ index + 1 }`,
          operation_id: item.bannerPictureInfoId
        })
      } catch (e) {
        console.log(e)
      }
      if(url.indexOf('http') == 0){
        window.location.href = url;
      }else{
        this.$router.push({path:url});
      }
    },
//    设置banner高度
    setHeight(){
      if($(document).width()>768){
        document.getElementById('el-carousel').style.height = this.bannerHeight + 'px';
      }else{
        document.getElementById('el-carousel').style.height = 109 + 'px';
      }
      
      window.onresize=function () {
        // console.log(2)
        // console.log($('.imgHeight0').height())
        this.bannerHeight=$('.imgHeight0').eq(0).height()
        // console.log(this.bannerHeight+'px')
        document.getElementById('el-carousel').style.height = this.bannerHeight + 'px';
      }
    },
    //    移动端手动滑动
    bannerScroll(){
      let $carousels = $('.el-carousel').eq(0);
      let start,   // 初始值
        end;    // 结束值
      $carousels.on('touchstart', function (e) {
        this.autoScroll = false;
        start = e.originalEvent.touches[0].clientX;// 触摸开始时记录一下手指所在的坐标x
      });
      $carousels.on('touchmove', function (e) {
        this.autoScroll = false;
        end = e.originalEvent.touches[0].clientX;// 离开屏幕一瞬间的坐标x
      });
      $carousels.on('touchend',  (e) => {
        let distance = Math.abs(start - end); // 获取差值
      if (distance > 30) {    //当差值大于30说明有方向的变化
        if(this.activeNum == 0){
          start > end ? this.$refs.carousel.setActiveItem(1) : this.$refs.carousel.setActiveItem(this.bannerInfo.length-1)
        }else{
          start > end ? this.$refs.carousel.setActiveItem(this.activeNum+1) : this.$refs.carousel.setActiveItem(this.activeNum-1)
        }
//          this.$refs.carousel.setActiveItem(0)//根据初始值和结束值的比较判断向前滑还是向后滑
      }
      this.autoScroll = true;
    })
    },
//    激活的幻灯片的索引
    activeNumFn(val){
      this.activeNum = val;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/purchaserBanner/index.vue